// extracted by mini-css-extract-plugin
export default {"tasks":"VN-z","task":"WN-z","svg":"XN-z","text":"YN-z"};